module.exports = __webpack_public_path__ + "static/grasflaeche-fdeb9f82c21be063a5e69b780e4db067.PNG";